import React from 'react'
import i18n from 'i18n-js'

import Input from '../../UI/Input/Input'

import './Artifacts.scss'

const Artifacts = props => {
    const artifacts = [
        {
            type: 'tel',
            id: 'atk_effect',
            value: props.artifacts?.atk_effect,
            label: i18n.t('artifact_atk_effect'),
            maxLength: 2
        },
        {
            type: 'tel',
            id: 's3_damage',
            value: props.artifacts?.s3_damage,
            label: i18n.t('artifact_s3_damage'),
            maxLength: 3
        },
        {
            type: 'number',
            id: 'dmg_percentage_hp',
            value: props.artifacts?.dmg_percentage_hp,
            label: i18n.t('dmg_percentage_hp'),
            maxLength: 3
        },
        {
            type: 'tel',
            id: 'dmg_percentage_atk',
            value: props.artifacts?.dmg_percentage_atk,
            label: i18n.t('dmg_percentage_atk'),
            maxLength: 3
        },
        {
            type: 'tel',
            id: 'dmg_percentage_def',
            value: props.artifacts?.dmg_percentage_def,
            label: i18n.t('dmg_percentage_def'),
            maxLength: 3
        },
        {
            type: 'tel',
            id: 'dmg_percentage_spd',
            value: props.artifacts?.dmg_percentage_spd,
            label: i18n.t('dmg_percentage_spd'),
            maxLength: 3
        }
    ]

    const ArtifactsClasses = ['Artifacts', props.withClass]

    return <div className={ArtifactsClasses.join(' ')}>
        {artifacts.map(el => <Input key={el.id} {...el} changed={evt => props.changed(evt, el.id)} />)}
    </div>
}

export default Artifacts